import { render, staticRenderFns } from "./AdvertsPostedBy.vue?vue&type=template&id=394c6f55&"
import script from "./AdvertsPostedBy.vue?vue&type=script&lang=js&"
export * from "./AdvertsPostedBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports